import { render, staticRenderFns } from "./ConversationNote.vue?vue&type=template&id=463340f0&scoped=true"
import script from "./ConversationNote.vue?vue&type=script&lang=js"
export * from "./ConversationNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463340f0",
  null
  
)

export default component.exports